import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
let ServicesPricingPackages = class ServicesPricingPackages extends Vue {
    msg;
};
ServicesPricingPackages = __decorate([
    Options({
        props: {
            msg: String,
        },
    })
], ServicesPricingPackages);
export default ServicesPricingPackages;
